module.exports = __webpack_public_path__ + "static/media/bpmeasurex-carrying-case-2.d6cbb029.png";